import React, { useContext } from "react";
import {
  SearchResultPlan,
  DrugCostInfo,
  PlanDetailsPageSection,
} from "../../@types";
import { useTranslate, sendTealiumEvent } from "../../helpers";
import { AppContext } from "../../app/store";
import { HashLink } from "react-router-hash-link";
import { PlanDetailsLink } from "..";

interface PharmaciesProps {
  plan: SearchResultPlan;
  drugCostInfo: DrugCostInfo;
  drugSelectionRoute: string;
  onGoToDrugSelection: () => void;
}

const Pharmacies: React.FunctionComponent<PharmaciesProps> = ({
  plan,
  drugCostInfo,
  drugSelectionRoute,
  onGoToDrugSelection,
}) => {
  const t = useTranslate();
  const {
    state: { pharmacies },
  } = useContext(AppContext);
  const { costs } = drugCostInfo;
  const coveredPharmacies =
    plan.remaining_premium_and_drugs && plan.pharmacies
      ? plan.pharmacies.filter(pharmacy => pharmacy.in_network)
      : costs.filter(c => c.in_network && !c.mail_order);

  return (
    <div className="PlanCard__section" data-testid="pharmacies">
      <h3 className="PlanCard__section_heading">
        {t("plan_card.section_heading.pharmacies")}
      </h3>
      {pharmacies.length ? (
        <div>
          <span className="PlanCard__data_small">
            {coveredPharmacies.length} {t("of")} {pharmacies.length}
          </span>{" "}
          {t("plan_card.covered_pharmacies")}
          <div className="ds-u-margin-top--1">
            <PlanDetailsLink
              label={t("plan_card.pharmacies.view_pharmacies")}
              plan={plan}
              section={PlanDetailsPageSection.DRUG_COVERAGE}
              onClick={(): void => {
                sendTealiumEvent(
                  "Find Plans - Available Plans",
                  "View your pharmacies"
                );
              }}
            />
          </div>
        </div>
      ) : (
        <div>
          <HashLink to={drugSelectionRoute} onClick={onGoToDrugSelection}>
            {t("plan_card.add_your_pharmacies")}
          </HashLink>
          <p className="ds-u-margin--0">
            {t("plan_card.add_your_pharmacies_info")}
          </p>
        </div>
      )}
    </div>
  );
};

export default Pharmacies;
